import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalSectionProps {
  title: string;
  children: React.ReactNode;
}
const LegalSection: React.FC<LegalSectionProps> = ({
  title,
  children
}) => {
  const [open, setOpen] = useState(false);
  return <div className="border-t border-cream/10" data-id="element-112">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-3 text-left text-cream/70 hover:text-cream transition-colors font-sans" aria-expanded={open} data-id="element-113">
        <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider" data-id="element-114">
          {title}
        </span>
        <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} data-id="element-115" />
      </button>
      <AnimatePresence initial={false} data-id="element-116">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="overflow-hidden" data-id="element-117">
            <div className="pb-5 pr-4 text-xs sm:text-sm font-sans text-cream/60 leading-relaxed space-y-3" data-id="element-118">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const Footer: React.FC = () => {
  return <footer className="w-full bg-navy text-cream/40 border-t border-cream/10" data-id="element-119">
      <div className="max-w-[680px] mx-auto px-5 sm:px-6 py-8 sm:py-10" data-id="element-120">
        {/* Sponsored disclaimer */}
        <p className="text-[11px] sm:text-xs font-sans leading-relaxed text-center py-5 text-cream/50" data-id="element-121">
          This is sponsored content. Results described reflect individual
          experiences. Digital product — instant delivery. No physical shipment.
        </p>

        {/* Legal collapsibles */}
        <div data-id="element-122">
          <LegalSection title="Privacy Policy" data-id="element-123">
            <p data-id="element-124">
              <strong className="text-cream/80" data-id="element-125">Last updated:</strong> May 2026
            </p>
            <p data-id="element-126">
              We respect your privacy. We collect only the information necessary
              to process your purchase and deliver your digital product: your
              name, email address, and payment information.
            </p>
            <p data-id="element-127">
              <strong className="text-cream/80" data-id="element-128">How we use your data:</strong>{' '}
              Your email is used solely to deliver the UNHOOKED digital book and
              to send transactional receipts. We do not share, sell, or rent
              your personal information to third parties.
            </p>
            <p data-id="element-129">
              <strong className="text-cream/80" data-id="element-130">Payment security:</strong> All
              payments are processed through Stripe with bank-level 256-bit SSL
              encryption. We never store your full credit card information on
              our servers.
            </p>
            <p data-id="element-131">
              <strong className="text-cream/80" data-id="element-132">Discreet billing:</strong>{' '}
              Charges appear on your statement under a generic, neutral business
              name. Nothing on your bank statement references the nature of this
              product.
            </p>
            <p data-id="element-133">
              <strong className="text-cream/80" data-id="element-134">Your rights:</strong> You may
              request access to, correction of, or deletion of your personal
              data at any time by contacting support@unhooked.com.
            </p>
            <p data-id="element-135">
              <strong className="text-cream/80" data-id="element-136">Cookies:</strong> We use minimal
              cookies necessary for site functionality and to remember your
              purchase. No third-party advertising cookies are used.
            </p>
          </LegalSection>

          <LegalSection title="Terms & Conditions" data-id="element-137">
            <p data-id="element-138">
              <strong className="text-cream/80" data-id="element-139">Last updated:</strong> May 2026
            </p>
            <p data-id="element-140">By purchasing UNHOOKED, you agree to the following terms.</p>
            <p data-id="element-141">
              <strong className="text-cream/80" data-id="element-142">Digital product:</strong>{' '}
              UNHOOKED is a digital book delivered immediately via email after
              successful payment. You will receive a download link valid for 30
              days. We recommend saving the file to your personal device.
            </p>
            <p data-id="element-143">
              <strong className="text-cream/80" data-id="element-144">License:</strong> Upon purchase
              you receive a single-user license for personal use. You may not
              redistribute, resell, copy, or share the book or its contents in
              whole or in part.
            </p>
            <p data-id="element-145">
              <strong className="text-cream/80" data-id="element-146">Refund policy:</strong> 30-day
              money-back guarantee. If you do not feel a difference after
              reading the book, contact support@unhooked.com within 30 days of
              purchase for a full refund — no questions asked.
            </p>
            <p data-id="element-147">
              <strong className="text-cream/80" data-id="element-148">Medical disclaimer:</strong>{' '}
              UNHOOKED is an educational and self-help product. It is not a
              substitute for professional medical, psychological, or psychiatric
              advice, diagnosis, or treatment. If you are struggling with
              addiction or mental health issues, please consult a qualified
              healthcare professional.
            </p>
            <p data-id="element-149">
              <strong className="text-cream/80" data-id="element-150">Results disclaimer:</strong>{' '}
              Individual results vary. The testimonials and results shared on
              this page reflect personal experiences and are not guaranteed
              outcomes for every reader.
            </p>
            <p data-id="element-151">
              <strong className="text-cream/80" data-id="element-152">
                Limitation of liability:
              </strong>{' '}
              The author and publisher are not liable for any direct, indirect,
              or consequential damages arising from the use or interpretation of
              the content of this book.
            </p>
          </LegalSection>
        </div>

        {/* Copyright */}
        <div className="pt-5 border-t border-cream/10 text-center" data-id="element-153">
          <p className="text-[11px] font-sans text-cream/30" data-id="element-154">
            © 2026 UNHOOKED. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};